import fetch from "auth/FetchInterceptor";
const TopTestsService = {};

TopTestsService.get = function (payload) {
  return fetch({
    url:
      "/reports/toptests?" +
      "startdate=" +
      payload.startDate +
      "&enddate=" +
      payload.endDate +
      "&agency=" +
      payload.agency +
      "&department=" +
      payload.department,
    method: "get",
  });
};

export default TopTestsService;
